import { Controller } from "@hotwired/stimulus"

// Offers the lifetimes of the chosen kind of CLI token, selecting that kind's default.
//
//   <form data-controller="cli-token-lifetime"
//         data-cli-token-lifetime-options-value='{"staff": [["90 days", 90]]}'
//         data-cli-token-lifetime-defaults-value='{"staff": 90}'>
//     <input type="radio" value="staff" data-action="cli-token-lifetime#change">
//     <select data-cli-token-lifetime-target="select"></select>
export default class extends Controller {
  static targets = ["select"]
  static values = { options: Object, defaults: Object }

  change(event) {
    const kind = event.target.value
    const options = this.optionsValue[kind] || []
    const selected = String(this.defaultsValue[kind])

    this.selectTarget.replaceChildren(...options.map(([label, value]) => {
      return new Option(label, value, false, String(value) === selected)
    }))
  }
}
